import { Modal } from "@covertree/ui";
import { Box, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";

interface QuoteTooltipProps {
  contactNumber: string;
}

export function QuoteTooltip({ contactNumber }: QuoteTooltipProps) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginY: 2,
          gap: 1,
        }}>
        <IconButton size="small" onClick={handleModalOpen}>
          <HelpOutlineIcon />
        </IconButton>
        <Typography align="center" variant="h6" color="textSecondary">
          Understanding my quote
        </Typography>
      </Box>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="md"
        title="Our insurance advisors can help you understand your policy">
        <Typography>
          Please call us at {contactNumber}, and we can walk you through every
          detail.
        </Typography>
      </Modal>
    </>
  );
}
